import React from 'react';
import { Baby, HeartPulse, Shield } from 'lucide-react';

const stages = [
  { title: 'Antenatal / Transplacentario', risk: '20–25%', text: 'Vía sincitiotrofoblasto y microtransfusiones.', Icon: Shield },
  { title: 'Intraparto', risk: '60–70%', text: 'Contacto con secreciones y sangre en el expulsivo.', Icon: HeartPulse, high: true },
  { title: 'Posparto / Lactancia', risk: '15–20% adicional acumulativo', text: 'Epitelio mucoso inmaduro.', Icon: Baby },
];

export const TransmissionDiagram = () => (
  <div className="mc-clinical-grid">
    {stages.map(({ title, risk, text, Icon, high }, index) => (
      <div key={title} data-testid={`transmission-stage-${index}`} className={`rounded-lg border p-4 ${high ? 'border-amber-300 bg-amber-50' : 'border-neutral-200 bg-white'}`}>
        <Icon size={22} className={high ? 'mb-3 text-amber-700' : 'mb-3 text-neutral-600'} />
        <h3 data-testid={`transmission-title-${index}`} className="text-sm font-bold">{title}</h3>
        <p data-testid={`transmission-risk-${index}`} className="my-3 text-lg font-extrabold">{risk}</p>
        {high && <span data-testid="transmission-high-risk-note" className="mb-2 block text-xs font-bold text-amber-800">¡Momento de mayor riesgo!</span>}
        <p data-testid={`transmission-description-${index}`} className="text-sm text-neutral-600">{text}</p>
      </div>
    ))}
  </div>
);